module.exports = __webpack_public_path__ + "img/404.a57b6f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404_images/404.png
// module id = 220
// module chunks = 1